import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { map } from 'rxjs/internal/operators/map';
import { ResponseData } from '../../models/response.model';
import { BaseService } from '../base.service';

@Injectable({
  providedIn: 'root'
})
export class DashboardService extends BaseService {
  protected get service(): string {
    return '';
  }

  public getDashboardData(): Observable<any[]> {
    return super.get<ResponseData>(this.service + '/bgv/dashboard/').pipe(
      map(response => {
        return response.results;
      })
    );
  }

  public getSpecificData(Id): Observable<any[]> {
    return super.get<ResponseData>(this.service + 'bgv/candidates/?resource_requirement=' + Id).pipe(
      map(response => {
        return response.results;
      })
    );
  }

  public getCandidateData(Id): Observable<any> {
    return super.get<ResponseData>(this.service + '/bgv/candidates/' + Id).pipe(
      map(response => {
        return response.results;
      })
    );
  }

  public saveCandidateComment(data): Observable<any[]> {
    return super.post<ResponseData>(this.service + 'comments/' ,data).pipe(
      map(response => {
        return response.results;
      })
    );
  }

  public updateComments(Id): Observable<any[]> {
    return super.get<ResponseData>(this.service + 'bgv/comments/'+ Id+'/' ).pipe(
      map(response => {
        return response.results;
      })
    );
  }


  public getVendor(Id): Observable<any[]> {
    return super.get<ResponseData>(this.service +'/bgv/?vendor='+ Id).pipe(
      map(response => {
        return response.results;
      })
    );
  }

  public getVendorb(): Observable<any[]> {
    return super.get<ResponseData>(this.service +'/bgv/count/').pipe(
      map(response => {
        return response.results;
      })
    );
  }



  public getVendorList(): Observable<any[]> {
    return super.get<ResponseData>(this.service +'/bgv/').pipe(
      map(response => {
        return response.results;
      })
    );
  }
  



  public adminPatch(body): Observable<any[]> {
    return super.patch<ResponseData>(this.service +'bgv/candidates/',body).pipe(
      map(response => {
        return response.results;
      })
    );
  }





  public getCandidateValues(id): Observable<any> {
    return super.get<ResponseData>(this.service + 'candidates/delta/'+id+'/').pipe(
      map(response => {
        return response.results;
      })
    );
  }

  public patchCandidateValues(id,body): Observable<any> {
    return super.patch<ResponseData>(this.service + 'candidates/delta/'+id+'/',body).pipe(
      map(response => {
        return response.results;
      })
    );
  }
 





  public approveValues(id,job,body): Observable<any> {
    return super.patch<ResponseData>(this.service + 'candidates/'+id+'/'+'jobs/'+job+'/',body).pipe(
      map(response => {
        return response.results;
      })
    );
  }

  public consentForm(): Observable<any> {
    return super.post<ResponseData>(this.service + '/candidates/consent_form/',{}).pipe(
      map(response => {
        return response.results;
      })
    );
  }


  
}
